import { useEffect } from "react";
import { getVanillaEl } from "../domBridge";

// Removes the target's static "d-none" while this route is mounted,
// re-adds it on unmount - the route-driven replacement for what
// viewSwitch.ts's showTopLevelView() used to do imperatively. The
// container itself (and, for #homeView specifically, its persistently-
// mounted static header controls wired by GalleryScreen.tsx) stays in the
// DOM the whole time; only this class toggles.
export function useVisibleContainer(id: string): void {
  useEffect(() => {
    const el = getVanillaEl<HTMLElement>(id);
    el?.classList.remove("d-none");
    return () => {
      el?.classList.add("d-none");
    };
  }, [id]);
}
